import Vue from 'vue'
import App from './App.vue'
/*Importas y usas VueRouter */
import VueRouter from 'vue-router'
import Axios from 'axios'
Vue.use(VueRouter);
Vue.use(Axios);

import { routes } from './routes'

const router = new VueRouter({
  mode: "history",
  routes: routes
});

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/es'
Vue.use(ElementUI, { locale })

import VueParticles from 'vue-particles'
Vue.use(VueParticles)

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)


import { library } from '@fortawesome/fontawesome-svg-core'
import { faComment } from '@fortawesome/free-solid-svg-icons'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import { faUniversity } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faMap } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faSignal } from '@fortawesome/free-solid-svg-icons'
import { faLaptopCode } from '@fortawesome/free-solid-svg-icons'
import { faHandsHelping } from '@fortawesome/free-solid-svg-icons'
import { faUsers } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faComment)
library.add(faCoins)
library.add(faSignal)
library.add(faUser)
library.add(faUniversity)
library.add(faPhone)
library.add(faMap)
library.add(faEnvelope)
library.add(faLaptopCode)
library.add(faHandsHelping)
library.add(faUsers)
library.add(faFacebook)
library.add(faTwitter)
library.add(faInstagram)
library.add(faWhatsapp)

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js